import { motion } from "framer-motion";
import { Building2, HardHat, Hammer, Sofa, TrafficCone, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    n: "01",
    icon: Building2,
    title: "Commercial Buildings",
    desc: "Offices, retail and mixed-use developments delivered end-to-end — from groundwork to handover.",
  },
  {
    n: "02",
    icon: HardHat,
    title: "Civil Construction",
    desc: "Structural works, groundworks, drainage and reinforced concrete built to engineering spec.",
  },
  {
    n: "03",
    icon: Hammer,
    title: "Renovation",
    desc: "Refurbishment and structural upgrades that breathe new life into existing properties.",
  },
  {
    n: "04",
    icon: Sofa,
    title: "Interiors & Fit-Out",
    desc: "Turnkey interior fit-outs with precision joinery, finishes and bespoke detailing.",
  },
  {
    n: "05",
    icon: TrafficCone,
    title: "Infrastructure",
    desc: "Roads, utilities and public works engineered for durability and community scale.",
  },
];

export const Services = () => {
  return (
    <section id="services" className="bg-ink py-24 md:py-36" data-testid="services">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-flame" />
              <span className="text-xs uppercase tracking-[0.35em] text-secondary-foreground/80">Capabilities</span>
            </div>
            <h2 className="font-heading font-black tracking-tighter text-4xl md:text-6xl max-w-2xl leading-[0.95]">
              Five disciplines, <span className="text-flame">one standard.</span>
            </h2>
          </div>
          <p className="max-w-sm text-secondary-foreground/80 md:text-right">
            Whatever the scope, every KTR project is held to the same benchmark of safety,
            precision and finish.
          </p>
        </div>

        <div className="border-t border-line">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                className="group grid grid-cols-12 items-center gap-4 border-b border-line py-8 md:py-10 hover:bg-elevated transition-colors duration-500 px-2 md:px-6"
                data-testid={`service-row-${s.n}`}
              >
                <span className="col-span-2 md:col-span-1 font-heading font-bold text-secondary-foreground/50 text-lg group-hover:text-flame transition-colors">
                  {s.n}
                </span>
                <div className="col-span-8 md:col-span-4 flex items-center gap-4">
                  <Icon className="h-6 w-6 text-flame shrink-0" />
                  <h3 className="font-heading font-bold tracking-tight text-2xl md:text-3xl">{s.title}</h3>
                </div>
                <p className="col-span-12 md:col-span-6 text-secondary-foreground/75 order-last md:order-none pl-10 md:pl-0">
                  {s.desc}
                </p>
                <ArrowUpRight className="hidden md:block col-span-1 h-7 w-7 justify-self-end text-secondary-foreground/40 group-hover:text-flame group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
